import { api, datesToISO, parseBoolean, success, swal } from "@";

// Fetch affiliate links with optional search parameters
export const getLinks = (page = 1, perSize = null, search = null) =>
  api.post(`/api/AdminAffiliateLink/search`, {
    Page: page,
    PageSize: perSize,
    searchKey: search?.keyword,
    fromDate: datesToISO(search?.fromDate) || null,
    toDate: datesToISO(search?.toDate) || null,
    affiliateId: parseInt(search?.user),
  });

// Toggle the active status of a link
export const linkToggleActive = (id, value) =>
  api.put(`/api/AdminAffiliateLink/${id}/IsActive?isActive=${value}`);

// Toggle the archive status of a link
export const linkToggleArchive = (id, value) =>
  api.put(`/api/AdminAffiliateLink/${id}/IsArchive?isArchive=${value}`);

// get affiliate link aggregation
export const getLinksAggregation = (search = null) =>
  api.post(`/api/AdminAffiliateLink/affiliate-links-aggregation`, {
    searchKey: search?.keyword,
    fromDate: datesToISO(search?.fromDate) || null,
    toDate: datesToISO(search?.toDate) || null,
    affiliateId: parseInt(search?.user),
  });

// Save a new link or update an existing one
export const saveLink = (data) => {
  const payload = {
    title: data.title,
    queryValue: data.queryValue,
    affiliateId: JSON.parse(data.affiliateId),
    numberOfCopies: JSON.parse(data.numberOfCopies || 0),
    creatCopies: parseBoolean(data.createCopies) || false,
  };
  if (data.id) {
    return api.put(`/api/AdminAffiliateLink/${data?.id}`, {
      title: data.title,
    });
  }
  return api.post("/api/AdminAffiliateLink", payload);
};

// Per-tab detail fetches for the "show link" page. Each tab is fetched
// lazily (on first open) instead of all at once — see ./queries.
export const getProjectsAffiliateLinks = (id) =>
  api.get(`/api/AdminAffiliateLink/projects-affiliate-links/${id}`);

export const getGiftProjectsAffiliateLinks = (id) =>
  api.get(`/api/AdminAffiliateLink/gift-projects-affiliate-links/${id}`);

export const getClassificationsAffiliateLinks = (id) =>
  api.get(`/api/AdminAffiliateLink/classifications-affiliate-links/${id}`);

export const getLandingPagesAffiliateLinks = (id) =>
  api.get(
    `/api/AdminAffiliateLink/landing-pages-affiliate-links/${id}`,
  );

// Perform multiple actions on links based on the type
export const linkMultiAction = async (type, ids) => {
  const res = await swal("هل أنت متأكد؟", "الرجاء تاكيد العملية", "نعم تاكيد");
  if (res.isConfirmed) {
    try {
      switch (type) {
        case "delete":
          await api.put(`/api/AdminAffiliateLink/delete-multiple`, {
            affiliateLinkIds: ids,
          });
          break;
        case "deActive":
          await api.put(`/api/AdminAffiliateLink/IsActive-multiple`, {
            affiliateLinkIds: ids,
            status: false,
          });
          break;
        case "active":
          await api.put(`/api/AdminAffiliateLink/IsActive-multiple`, {
            affiliateLinkIds: ids,
            status: true,
          });
          break;
        case "archive":
          await api.put(`/api/AdminAffiliateLink/IsArchive-multiple`, {
            affiliateLinkIds: ids,
            status: true,
          });
          break;
        case "deArchive":
          await api.put(`/api/AdminAffiliateLink/IsArchive-multiple`, {
            affiliateLinkIds: ids,
            status: false,
          });
          break;
      }
      await success("العملية تمت بنجاح");
      return 200;
    } catch (error) {
      // Handle error if needed
    }
  }
};
